// extracted by mini-css-extract-plugin
module.exports = {"MasterDeviceIdSelector":"MasterDeviceIdSelector___XiuNm"};